/* eslint-disable no-restricted-imports */
import {
  DialogActions as MuiDialogActions,
  DialogActionsProps as MuiDialogActionsProps,
} from '@material-ui/core';
import { dialogActionsStyles } from './dialogActionsCssDefs';

export type DialogActionsProps = MuiDialogActionsProps;

/**
 * @deprecated Deprecated — use pantry Modal.Footer instead.
 * @see https://docs.tocktix.com/pantry?path=/docs/components-modal-modal-footer--docs
 */
export const DialogActions = (props: DialogActionsProps) => {
  return <MuiDialogActions css={dialogActionsStyles} {...props} />;
};
